import 'array.prototype.flat';

import {getGradeNumber} from 'utils/gradeLevels';

const groupConsecutiveGradeLevels = (array) => {
  return array.reduce((acc, cur, i) => {
    if (i === 0) {
      acc.push([cur]);
      return acc;
    }
    if (array[i - 1] + 1 !== cur) acc.push([]);
    acc[acc.length - 1].push(cur);
    return acc;
  }, []);
};

export const gradesFormatter = (gradesArray) => {
  const consecutiveGradesArray = groupConsecutiveGradeLevels(gradesArray.sort((str1, str2) => {
    return getGradeNumber(str1) - getGradeNumber(str2);
  }));
  const consecutiveGradesArrayFlat = consecutiveGradesArray.flat();
  if (consecutiveGradesArrayFlat.length === 1) {
    return consecutiveGradesArrayFlat[0] !== '' ? `Grade: ${consecutiveGradesArrayFlat[0]}` : '';
  } else {
    return `Grades: ${consecutiveGradesArrayFlat[0]}-${consecutiveGradesArrayFlat[consecutiveGradesArrayFlat.length - 1]}`;
  }
};
